export const paths = {
	home: '/',
	prospects: '/prospects',
	newBusiness: '/new-business',
	createNewBusiness: '/create-new-business',
	renewals: '/renewals',
	createRenewal: '/create-renewal',
	createDebtor: '/create-debtor',
	createClient: '/create-client',
	claims: '/claims',
	createClaim: '/create-claim',
	endorsements: '/endorsements',
	createEndorsement: '/create-endorsement',
	clients: '/clients',
	tasks: '/my-tasks',
	relationships: '/relationships',
	companies: '/companies',
	generateSOA: '/generate-soa',
	settings: '/settings',
	templates: '/templates',
	unlayerTemplates: '/unlayer-templates',
	unlayerDocumentTemplates: '/unlayer-document-templates',
	automations: '/automations',
	adminConsent: '/admin-consent',
	adminConsentProcess: '/admin-consent-process',
	learnDash: 'https://learning.folio.insure/wp-login.php',
	helpAndSupport: 'https://tutorialsite.z8.web.core.windows.net/',
	debtors: '/debtors',
	deals: '/deals', // generic deals view for rerouting
	audit: '/audit',
	admin: '/admin',
	adminUsers: '/admin/users',
	adminNetworks: '/admin/networks',
	adminBrokers: '/admin/brokers',
	adminClients: '/admin/clients',
	adminFeatureFlags: '/admin/feature-flags',
};

